module.exports = __webpack_public_path__ + "res/img/icon-word.3d308d85.png";